module.exports = __webpack_public_path__ + "media/digital/CustomerAvatar-16904f7d.png";